<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  placeholder="Key in folder"
                  append-icon="search"
                  label="Search folder name"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Folder's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-quality-management-folders-dialog-create
                  @created="loadQMFolder"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredQualityManagementFolders"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-quality-management-folders-dialog-edit
                  :quality-management-folder="item"
                  @updated="refreshData"
                />
                <span class="mx-1" />
                <setup-quality-management-folders-dialog-delete
                  :quality-management-folder="item"
                  @deleted="refreshData"
                />
              </span>
              <span v-else>
                <setup-quality-management-folders-dialog-restore
                  :quality-management-folder="item"
                  @restored="refreshData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupQualityManagementFoldersDialogCreate: () => import('@/components/setup/quality-management-folders/DialogCreate'),
      SetupQualityManagementFoldersDialogDelete: () => import('@/components/setup/quality-management-folders/DialogDelete'),
      SetupQualityManagementFoldersDialogRestore: () => import('@/components/setup/quality-management-folders/DialogRestore'),
      SetupQualityManagementFoldersDialogEdit: () => import('@/components/setup/quality-management-folders/DialogEdit'),
    },
    data () {
      return {
        qualityManagementFolders: [],
        trashedQualityManagementFolders: [],
        headers: [
          {
            text: 'Folder name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: false,
      }
    },
    computed: {
      filteredQualityManagementFolders () {
        return this.statusFilter ? this.qualityManagementFolders : this.trashedQualityManagementFolders
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadQMFolder () {
        this.tableLoading = true

        this.$api.qualityManagementFolders().list()
          .then(res => {
            this.qualityManagementFolders = res.data
          
            this.tableLoading = false
          })
      },
      loadTrashedQMFolder () {
        this.$api.qualityManagementFolders().listTrashed()
          .then(response => {
            this.trashedQualityManagementFolders = response.data
          })
      },
      refreshData () {
        this.loadQMFolder()
        this.loadTrashedQMFolder()
      },
    },
  }
</script>
